import { Label, TooltipDesktop, UIText2 } from '@cian/ui-kit';
import { IconProductHighDemand16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';

export function DiscountMortgageLabel() {
  return (
    <TooltipDesktop
      title={
        <UIText2 color="text-inverted-default">
          Подробнее узнавайте <br /> у застройщика
        </UIText2>
      }
      theme="black"
    >
      <div className={styles['label']}>
        <Label
          background="decorative-accent-lavender-transparent"
          color="decorative-accent-purple"
          icon={<IconProductHighDemand16 color="decorative-accent-purple" />}
        >
          Льготная ипотека
        </Label>
      </div>
    </TooltipDesktop>
  );
}
